export default {
  loadingScreen: {
    id: 'bo_sellers-listing-search-product-card-detail-loading-screen',
    defaultMessage: 'Loading product details...',
  },
  errorTitle: {
    id: 'bo_sellers-listing-search-product-card-detail-error-title',
    defaultMessage: 'Oops an error occured',
  },
  errorMessage: {
    id: 'bo_sellers-listing-search-product-card-detail-error-message',
    defaultMessage:
      'Sorry, an error occured while retrieving the product attributes.',
  },
}
